import { createSlice } from "@reduxjs/toolkit";

// mobile phone and accessories
// usb-charger-cable
import usbChargerCable1 from '../../../Images/mobilesAndAccessories/usb-charger-cable/1.png';
import usbChargerCable2 from '../../../Images/mobilesAndAccessories/usb-charger-cable/2.png';
import usbChargerCable3 from '../../../Images/mobilesAndAccessories/usb-charger-cable/3.png';
import usbChargerCable4 from '../../../Images/mobilesAndAccessories/usb-charger-cable/4.png';
import usbChargerCable5 from '../../../Images/mobilesAndAccessories/usb-charger-cable/5.jpg';
import usbChargerCable6 from '../../../Images/mobilesAndAccessories/usb-charger-cable/6.jpg';
// headphone
import headphone1 from '../../../Images/mobilesAndAccessories/headphone/1.png';
import headphone2 from '../../../Images/mobilesAndAccessories/headphone/2.jpg';
import headphone3 from '../../../Images/mobilesAndAccessories/headphone/3.jpg';
import headphone4 from '../../../Images/mobilesAndAccessories/headphone/4.jpg';
import headphone5 from '../../../Images/mobilesAndAccessories/headphone/5.jpg';
// phone-grip-black
import phoneGripBlack1 from '../../../Images/mobilesAndAccessories/phone-grip-black/1.png';
import phoneGripBlack2 from '../../../Images/mobilesAndAccessories/phone-grip-black/2.png';
import phoneGripBlack3 from '../../../Images/mobilesAndAccessories/phone-grip-black/3.jpg';
import phoneGripBlack4 from '../../../Images/mobilesAndAccessories/phone-grip-black/4.jpg';
import phoneGripBlack5 from '../../../Images/mobilesAndAccessories/phone-grip-black/5.jpg';
import phoneGripBlack6 from '../../../Images/mobilesAndAccessories/phone-grip-black/6.jpg';
// smartphone-stabilizer
import smartphoneStabilizer1 from '../../../Images/mobilesAndAccessories/smartphone-stabilizer/1.png';
import smartphoneStabilizer2 from '../../../Images/mobilesAndAccessories/smartphone-stabilizer/2.jpg';
import smartphoneStabilizer3 from '../../../Images/mobilesAndAccessories/smartphone-stabilizer/3.jpg';
import smartphoneStabilizer4 from '../../../Images/mobilesAndAccessories/smartphone-stabilizer/4.jpg';
// phone-grip-clear
import phoneGripClear1 from '../../../Images/mobilesAndAccessories/phone-grip-clear/1.png';
import phoneGripClear2 from '../../../Images/mobilesAndAccessories/phone-grip-clear/2.jpg';
import phoneGripClear3 from '../../../Images/mobilesAndAccessories/phone-grip-clear/3.jpg';
import phoneGripClear4 from '../../../Images/mobilesAndAccessories/phone-grip-clear/4.jpg';
import phoneGripClear5 from '../../../Images/mobilesAndAccessories/phone-grip-clear/5.jpg';
import phoneGripClear6 from '../../../Images/mobilesAndAccessories/phone-grip-clear/6.jpg';

// electronics
// RadarDetectors
import radar1 from '../../../Images/electronicsAndGadgets/RadarDetectors/1.png';
import radar2 from '../../../Images/electronicsAndGadgets/RadarDetectors/2.jpg';
import radar3 from '../../../Images/electronicsAndGadgets/RadarDetectors/3.jpg';
import radar4 from '../../../Images/electronicsAndGadgets/RadarDetectors/4.jpg';
import radar5 from '../../../Images/electronicsAndGadgets/RadarDetectors/5.jpg';
// PanasonicCamera
import camera1 from '../../../Images/electronicsAndGadgets/panasonicLumix/1.png';
import camera2 from '../../../Images/electronicsAndGadgets/panasonicLumix/2.png';
import camera3 from '../../../Images/electronicsAndGadgets/panasonicLumix/3.png';
import camera4 from '../../../Images/electronicsAndGadgets/panasonicLumix/4.png';
import camera5 from '../../../Images/electronicsAndGadgets/panasonicLumix/5.png';
import camera6 from '../../../Images/electronicsAndGadgets/panasonicLumix/6.png';
// duracell
import cell1 from '../../../Images/electronicsAndGadgets/duracell/1.jpg';
import cell2 from '../../../Images/electronicsAndGadgets/duracell/2.jpg';
import cell3 from '../../../Images/electronicsAndGadgets/duracell/3.jpg';
import cell4 from '../../../Images/electronicsAndGadgets/duracell/4.jpg';
import cell5 from '../../../Images/electronicsAndGadgets/duracell/5.jpg';
// ring
import ring1 from '../../../Images/electronicsAndGadgets/UBeesize/1.png';
import ring2 from '../../../Images/electronicsAndGadgets/UBeesize/2.jpg';
import ring3 from '../../../Images/electronicsAndGadgets/UBeesize/3.jpg';
import ring4 from '../../../Images/electronicsAndGadgets/UBeesize/4.jpg';
import ring5 from '../../../Images/electronicsAndGadgets/UBeesize/5.jpg';
// HPsprocket
import sprocket1 from '../../../Images/electronicsAndGadgets/HPsprocket/1.png';
import sprocket2 from '../../../Images/electronicsAndGadgets/HPsprocket/2.jpg';
import sprocket3 from '../../../Images/electronicsAndGadgets/HPsprocket/3.jpg';
import sprocket4 from '../../../Images/electronicsAndGadgets/HPsprocket/4.jpg';
import sprocket5 from '../../../Images/electronicsAndGadgets/HPsprocket/5.jpg';

// homeAndKitchen
// nutriChef
import nutriChef1 from '../../../Images/homeAndKitchen/nutriChef/1.png';
import nutriChef2 from '../../../Images/homeAndKitchen/nutriChef/2.jpg';
import nutriChef3 from '../../../Images/homeAndKitchen/nutriChef/3.jpg';
import nutriChef4 from '../../../Images/homeAndKitchen/nutriChef/4.jpg';
import nutriChef5 from '../../../Images/homeAndKitchen/nutriChef/5.jpg';
import nutriChef6 from '../../../Images/homeAndKitchen/nutriChef/6.jpg';

// utensils
import utensil1 from '../../../Images/homeAndKitchen/utensils/1.png';
import utensil2 from '../../../Images/homeAndKitchen/utensils/2.png';
import utensil3 from '../../../Images/homeAndKitchen/utensils/3.png';
import utensil4 from '../../../Images/homeAndKitchen/utensils/4.jpg';
import utensil5 from '../../../Images/homeAndKitchen/utensils/5.jpg';
import utensil6 from '../../../Images/homeAndKitchen/utensils/6.jpg';
// cooker
import cooker1 from '../../../Images/homeAndKitchen/cooker/1.png';
import cooker2 from '../../../Images/homeAndKitchen/cooker/2.png';
import cooker3 from '../../../Images/homeAndKitchen/cooker/3.png';
import cooker4 from '../../../Images/homeAndKitchen/cooker/4.jpg';
// oven
import oven1 from '../../../Images/homeAndKitchen/oven/1.png';
import oven2 from '../../../Images/homeAndKitchen/oven/2.jpg';
import oven3 from '../../../Images/homeAndKitchen/oven/3.jpg';
import oven4 from '../../../Images/homeAndKitchen/oven/4.jpg';
import oven5 from '../../../Images/homeAndKitchen/oven/5.jpg';
// kitchenArt
import art1 from '../../../Images/homeAndKitchen/kitchenArt/1.png';
import art2 from '../../../Images/homeAndKitchen/kitchenArt/2.jpg';
import art3 from '../../../Images/homeAndKitchen/kitchenArt/3.png';
import art4 from '../../../Images/homeAndKitchen/kitchenArt/4.jpg';
import art5 from '../../../Images/homeAndKitchen/kitchenArt/5.jpg';

// beauty
// firstAid
import firstAid1 from '../../../Images/beautyAndPersonalCare/firstAid/1.png';
import firstAid2 from '../../../Images/beautyAndPersonalCare/firstAid/2.png';
import firstAid3 from '../../../Images/beautyAndPersonalCare/firstAid/3.jpg';
import firstAid4 from '../../../Images/beautyAndPersonalCare/firstAid/4.jpg';
import firstAid5 from '../../../Images/beautyAndPersonalCare/firstAid/5.jpg';

// lipbalm
import lipbalm1 from '../../../Images/beautyAndPersonalCare/lipbalm/1.png';
import lipbalm2 from '../../../Images/beautyAndPersonalCare/lipbalm/2.png';
import lipbalm3 from '../../../Images/beautyAndPersonalCare/lipbalm/3.jpg';
import lipbalm4 from '../../../Images/beautyAndPersonalCare/lipbalm/4.jpg';
import lipbalm5 from '../../../Images/beautyAndPersonalCare/lipbalm/5.jpg';

// dove
import dove1 from '../../../Images/beautyAndPersonalCare/dove/1.jpg';
import dove2 from '../../../Images/beautyAndPersonalCare/dove/2.jpg';
import dove3 from '../../../Images/beautyAndPersonalCare/dove/3.jpg';
import dove4 from '../../../Images/beautyAndPersonalCare/dove/4.jpg';
import dove5 from '../../../Images/beautyAndPersonalCare/dove/5.jpg';

// hairRemoval
import hairRemoval1 from '../../../Images/beautyAndPersonalCare/hairRemoval/1.png';
import hairRemoval2 from '../../../Images/beautyAndPersonalCare/hairRemoval/2.jpg';
import hairRemoval3 from '../../../Images/beautyAndPersonalCare/hairRemoval/3.jpg';
import hairRemoval4 from '../../../Images/beautyAndPersonalCare/hairRemoval/4.jpg';
import hairRemoval5 from '../../../Images/beautyAndPersonalCare/hairRemoval/5.jpg';
import hairRemoval6 from '../../../Images/beautyAndPersonalCare/hairRemoval/6.jpg';

// shampoo
import shampoo1 from '../../../Images/beautyAndPersonalCare/shampoo/1.png';
import shampoo2 from '../../../Images/beautyAndPersonalCare/shampoo/2.jpg';
import shampoo3 from '../../../Images/beautyAndPersonalCare/shampoo/3.jpg';
import shampoo4 from '../../../Images/beautyAndPersonalCare/shampoo/4.jpg';

const productsSlice = createSlice({
    name: 'products',
    initialState: {
        active: 'mobilephonesandaccessories',
        products: [
            // mobiles
            {
                id: 1,
                title: 'Amazon Basics USB 2.0 Charger Cable - A-Male to Mini-B Cord - 3 Feet (0.9 Meters) for Personal Computer',
                category: 'mobilephonesandaccessories',
                redirectionLink: 'https://amzn.to/3YTn2Kx',
                images:[
                    {id: 'usbchargerCable1', img: usbChargerCable1},
                    {id: 'usbchargerCable2', img: usbChargerCable2},
                    {id: 'usbchargerCable3', img: usbChargerCable3},
                    {id: 'usbchargerCable4', img: usbChargerCable4},
                    {id: 'usbchargerCable5', img: usbChargerCable5},
                    {id: 'usbchargerCable6', img: usbChargerCable6},
                ],
                blog:{
                    title: 'Why Amazon Basics USB 2.0 Charger Cable is the Perfect Cord for your PC',

                    introduction: {
                        heading: 'Say Goodbye to Frayed Cables with the Amazon Basics USB 2.0 Charger Cable',
                        text: 'Are you tired of constantly replacing your frayed or malfunctioning charger cables? Do you want a reliable and affordable option for your personal computer? Look no further than the Amazon Basics USB 2.0 Charger Cable - A-Male to Mini-B Cord - 3 Feet (0.9 meters).'
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'High-Quality Materials',
                            text: 'The Amazon Basics USB 2.0 Charger Cable is made with high-quality materials, ensuring durability and longevity. The cable is reinforced with a sturdy exterior jacket and features corrosion-resistant connectors. Say goodbye to flimsy cables that break or stop working after a few uses.'
                        },
                        {
                            id: 2,
                            heading: 'Convenient Length',
                            text: 'At 3 feet (0.9 meters), this cable is the perfect length for personal computer use. It is long enough to give you some flexibility in where you position your computer but not so long that it gets tangled up or takes up too much space on your desk.'
                        },
                        {
                            id: 3,
                            heading: 'Compatibility',
                            text: 'This charger cable is compatible with a wide range of devices, including but not limited to, digital cameras, MP3 players, and game controllers. It is a versatile and reliable option for anyone looking for a durable and affordable charging solution.'
                        },
                        {
                            id: 4,
                            heading: 'Affordable Price',
                            text: 'One of the best things about the Amazon Basics USB 2.0 Charger Cable is its price. At a fraction of the cost of other charging cables on the market, you will not have to break the bank to replace your old or broken cables.'
                        },
                        {
                            id: 5,
                            heading: 'Customer Reviews',
                            text: 'Do not just take our word for it - check out the customer reviews on Amazon. Users rave about the quality and durability of this charger cable, with many saying that it is a great value for the price.'
                        },
                    ],

                    conclusion: {
                        heading: `A Purchase You Won't Regret`,
                        text: 'In conclusion, if you are in the market for a reliable and affordable charger cable for your personal computer, the Amazon Basics USB 2.0 Charger Cable - A-Male to Mini-B Cord - 3 Feet (0.9 meters) is an excellent choice. With high-quality materials, convenient length, compatibility with a range of devices, and an affordable price, you can not go wrong with this cable.'
                    },
                    youtubeLink: 'https://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 2,
                title: 'Bose QuietComfort 45 Bluetooth Wireless Noise Cancelling Headphones - White Smoke',
                category: 'mobilephonesandaccessories',
                redirectionLink: 'https://amzn.to/3Fxqbsk',
                images:[
                    {id: 'headphone1', img: headphone1},
                    {id: 'headphone2', img: headphone2},
                    {id: 'headphone3', img: headphone3},
                    {id: 'headphone4', img: headphone4},
                    {id: 'headphone5', img: headphone5},
                ],
                blog:{
                    title: 'Why Bose QuietComfort 45 Bluetooth Wireless Noise Cancellation Headphones are Worth Every Penny',

                    introduction: {
                        heading: 'Experience Serenity With Bose QuietComfort 45 Wireless Headphones',
                        text: 'Have you ever found yourself unable to concentrate on your work or your music because of the noise around you? The hustle and bustle of everyday life can be overwhelming, but with Bose QuietComfort 45 Wireless Headphones, you can enjoy the peace and quiet you deserve.'
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Noise Cancellation that Surpasses Expectations',
                            text: 'The Bose QuietComfort 45 headphones are equipped with advanced noise-cancellation technology that can block out even the loudest and most persistent background noise. Whether you are commuting on a train, working in a noisy office, or just want to enjoy your music in peace, these headphones will deliver unparalleled noise cancellation that will allow you to fully immerse yourself in your music or work.'
                        },
                        {
                            id: 2,
                            heading: 'Unmatched Sound Quality',
                            text: 'Not only do the Bose QuietComfort 45 headphones block out noise, but they also deliver exceptional sound quality. The headphones feature premium drivers and advanced equalization technology that produce rich, balanced, and detailed sound. You will be able to hear every instrument and every note, just as the artist intended.'
                        },
                        {
                            id: 3,
                            heading: 'Enhanced Comfort and Long-Lasting Battery Life',
                            text: 'The Bose QuietComfort 45 headphones are designed with your comfort in mind. The headband is made from soft materials that provide a comfortable fit even during long listening sessions. The earcups are also made from plush materials that conform to the shape of your ears, providing excellent noise isolation and comfort. What is more, these headphones have a long-lasting battery life of up to 24 hours. You can enjoy your music all day without worrying about running out of battery. And when the battery does run low, a quick 15-minute charge provides an extra 3 hours of listening time.'
                        },
                        {
                            id: 4,
                            heading: 'Seamless Connectivity and Easy Controls',
                            text: 'The Bose QuietComfort 45 headphones use Bluetooth technology to connect to your devices wirelessly. Pairing is easy and seamless, and you can connect to multiple devices at once. You can also use the Bose Music app to personalize your listening experience and access features like EQ settings and noise-cancellation controls. The headphones also have intuitive touch controls that allow you to adjust the volume, skip tracks, and answer calls with just a few taps. You can even activate your phone is voice assistant with the touch of a button.'
                        },
                        {
                            id: 5,
                            heading: 'Stylish and Durable Design',
                            text: 'The QuietComfort 45 headphones are not only functional but also stylish. The white smoke color scheme is eye-catching and modern, and the headphones are designed to be durable and long-lasting. You can wear them with confidence, knowing that they will withstand the wear and tear of everyday use.'
                        },
                    ],
                    
                    conclusion: {
                        heading: `A Purchase You Won't Regret`,
                        text: 'Investing in a pair of Bose QuietComfort 45 headphones is a purchase you will not regret. These headphones offer exceptional noise cancellation, unmatched sound quality, all-day comfort, and convenient connectivity. They are perfect for music lovers, professionals, and anyone who values high-quality audio and comfort. Do not hesitate to invest in these headphones and experience the difference for yourself.'
                    },
                    youtubeLink: 'https://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 3,
                title: 'PopSockets PopGrip for MagSafe: Grip and Stand for Phones and Cases, Remove and Reposition, Swappable Top, Black',
                category: 'mobilephonesandaccessories',
                redirectionLink: 'https://amzn.to/3lknt2P',
                images:[
                    {id: 'phoneGripBlack1', img: phoneGripBlack1},
                    {id: 'phoneGripBlack2', img: phoneGripBlack2},
                    {id: 'phoneGripBlack3', img: phoneGripBlack3},
                    {id: 'phoneGripBlack4', img: phoneGripBlack4},
                    {id: 'phoneGripBlack5', img: phoneGripBlack5},
                    {id: 'phoneGripBlack6', img: phoneGripBlack6}
                ],
                blog:{
                    title: 'PopSockets PopGrip for MagSafe: The Must-Have Accessory for Your Phone!',

                    introduction: {
                        heading: 'Elevate Your Phone Experience with PopSockets PopGrip for MagSafe!',
                        text: 'Are you tired of dropping your phone or struggling to hold it for extended periods? Do you want a stylish accessory that also provides a secure grip and stand for your phone? Look no further than the PopSockets PopGrip for MagSafe!'
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'A Grip and Stand You Can Count On',
                            text: 'The PopSockets PopGrip for MagSafe offers a reliable grip that prevents your phone from slipping out of your hands. With its comfortable, textured surface, you can easily hold your phone for extended periods without worrying about it slipping or falling. Additionally, the PopGrip doubles as a stand, allowing you to prop up your phone for hands-free viewing of videos or photos.'
                        },
                        {
                            id: 2,
                            heading: 'Easy to Install and Swap',
                            text: 'The PopSockets PopGrip for MagSafe attaches seamlessly to your MagSafe-compatible phone or case. No need for messy adhesives or complicated installation procedures. Plus, the PopGrip is swappable, meaning you can easily remove and reposition it on your phone or switch it out for a different design.'
                        },
                        {
                            id: 3,
                            heading: 'Stylish and Customizable',
                            text: `The PopSockets PopGrip for MagSafe comes in a sleek black design that complements any phone or case. But that's not all – you can also customize your PopGrip with interchangeable PopTops that come in a variety of colors and designs. Show off your personality and style with a PopGrip that's uniquely yours.`
                        },
                        {
                            id: 4,
                            heading: 'Trusted and Reliable Brand',
                            text: 'PopSockets is a trusted and reliable brand that has been providing quality phone accessories for years. You can trust that the PopSockets PopGrip for MagSafe is made with high-quality materials and will last for years to come.'
                        },
                        {
                            id: 5,
                            heading: 'The Perfect Gift for Your Phone-Obsessed Friends',
                            text: 'If you have friends or family members who are constantly on their phones, the PopSockets PopGrip for MagSafe makes the perfect gift. Not only does it provide a secure grip and stand, but its swappable design allows for endless customization options. Give the gift of convenience, style, and functionality with the PopSockets PopGrip for MagSafe.'
                        },
                    ],
                    
                    conclusion: {
                        heading: `Don't Settle for a Mediocre Phone Grip - Get the PopSockets PopGrip for MagSafe`,
                        text: 'The PopSockets PopGrip for MagSafe is a must-have accessory for anyone looking for a secure grip and stand for their phone. With its easy installation, swappable design, and customizable options, the PopGrip is the perfect blend of functionality and style. Trust in the reliable brand of PopSockets to provide you with a top-quality phone accessory that will make your life easier and more stylish!'
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 4,
                title: 'DJI Osmo Mobile 6 Smartphone Gimbal Stabilizer, 3-Axis Phone Gimbal, Built-In Extension Rod, Portable and Foldable, Android and iPhone Gimbal with ShotGuides, Vlogging Stabilizer, YouTube TikTok Video',
                category: 'mobilephonesandaccessories',
                redirectionLink: 'https://amzn.to/3n5KpmB',
                images:[
                    {id: 'smartphoneStabilizer1', img: smartphoneStabilizer1},
                    {id: 'smartphoneStabilizer2', img: smartphoneStabilizer2},
                    {id: 'smartphoneStabilizer3', img: smartphoneStabilizer3},
                    {id: 'smartphoneStabilizer4', img: smartphoneStabilizer4},
                ],
                blog:{
                    title: 'DJI Osmo Mobile 6: The Ultimate Smartphone Gimbal Stabilizer for Vlogging and More!',

                    introduction: {
                        heading: 'Take Your Mobile Filmmaking to the Next Level with DJI Osmo Mobile 6 Gimbal!',
                        text: 'Are you tired of shaky, unprofessional-looking footage on your smartphone videos? Do you want to take your content creation game to the next level? Look no further than the DJI Osmo Mobile 6 Smartphone Gimbal Stabilizer!'
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Smooth and Steady Shots Every Time',
                            text: 'The DJI Osmo Mobile 6 is a 3-axis phone gimbal stabilizer that eliminates shaky footage and ensures smooth and steady shots every time. With its advanced stabilization technology, you can capture professional-grade videos that are sure to impress your followers and fans.'
                        },
                        {
                            id: 2,
                            heading: 'Built-In Extension Rod for Creative Flexibility',
                            text: `The DJI Osmo Mobile 6 comes with a built-in extension rod that provides up to 215mm of extra reach, allowing you to capture unique and creative shots from different angles. Whether you're vlogging, live streaming, or shooting a short film, the extension rod gives you the flexibility you need to capture the perfect shot.`
                        },
                        {
                            id: 3,
                            heading: 'Portable and Foldable Design for On-The-Go Use',
                            text: `The DJI Osmo Mobile 6 is designed for on-the-go use, with its portable and foldable design making it easy to take with you anywhere. Whether you're traveling, hiking, or just out and about, the DJI Osmo Mobile 6 is a compact and convenient tool that will help you capture stunning footage.`
                        },
                        {
                            id: 4,
                            heading: 'ShotGuides for Easy, Professional Shots',
                            text: `The DJI Osmo Mobile 6 also features ShotGuides, which provide you with easy-to-follow instructions for capturing professional-quality shots. Whether you're a beginner or an experienced content creator, ShotGuides take the guesswork out of capturing the perfect shot.`
                        },
                        {
                            id: 5,
                            heading: 'Compatible with Android and iPhone',
                            text: 'The DJI Osmo Mobile 6 is compatible with both Android and iPhone smartphones, making it a versatile and convenient accessory for any content creator. Whether you have an iPhone or an Android device.'
                        },
                    ],
                    
                    conclusion: {
                        heading: `Invest in the Best - DJI Osmo Mobile 6 Smartphone Gimbal Stabilizer`,
                        text: `Investing in the DJI Osmo Mobile 6 Gimbal means investing in your creativity and the quality of your content. Its portable and foldable design also makes it the perfect accessory for on-the-go filmmaking. Don't settle for shaky and amateur-looking footage – upgrade to the DJI Osmo Mobile 6 Gimbal and take your mobile filmmaking to the next level!`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 5,
                title: 'PopSockets: Phone Grip for MagSafe, Phone Holder, Wireless Charging Compatible - Clear',
                category: 'mobilephonesandaccessories',
                redirectionLink: 'https://amzn.to/3LweHcD',
                images:[
                    {id: 'phoneGripClear1', img: phoneGripClear1},
                    {id: 'phoneGripClear2', img: phoneGripClear2},
                    {id: 'phoneGripClear3', img: phoneGripClear3},
                    {id: 'phoneGripClear4', img: phoneGripClear4},
                    {id: 'phoneGripClear5', img: phoneGripClear5},
                    {id: 'phoneGripClear6', img: phoneGripClear6},
                ],
                blog:{
                    title: 'Get a Grip on Your Phone with PopSockets PopGrip for MagSafe',

                    introduction: {
                        heading: 'Introduction to PopSockets PopGrip for MagSafe',
                        text: `Do you ever feel like your phone is just too slippery to hold on to? Or maybe you've dropped it one too many times and you're tired of dealing with the consequences. Enter the PopSockets PopGrip for MagSafe – the perfect accessory to help you get a grip on your phone.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Customizable Design',
                            text: `The PopSockets PopGrip for MagSafe is not only functional, but it's also customizable to fit your personal style. With swappable tops, you can change the look of your PopGrip whenever you want. Choose from a variety of colors and designs to make your PopGrip truly unique.`
                        },
                        {
                            id: 2,
                            heading: 'Convenient Stand',
                            text: `In addition to providing a secure grip, the PopSockets PopGrip can also be used as a stand for your phone. Whether you want to watch a movie, make a video call, or take photos hands-free, the PopGrip has got you covered. Its stable base ensures that your phone won't tip over or fall.`
                        },
                        {
                            id: 3,
                            heading: 'Easy to Use',
                            text: `The PopSockets PopGrip for MagSafe is incredibly easy to use. Simply attach it to the back of your phone and you're ready to go. The swappable tops are easy to remove and replace, and the MagSafe technology ensures that your PopGrip stays in place.`
                        },
                        {
                            id: 4,
                            heading: 'Wireless Charging Compatibility',
                            text: `One of the standout features of the PopSockets PopGrip for MagSafe is its wireless charging compatibility. You no longer have to worry about removing the grip to charge your phone. The PopGrip is designed to work with wireless chargers, making it more convenient and hassle-free to use.`
                        },
                        {
                            id: 5,
                            heading: 'Durability and Longevity',
                            text: `The PopSockets PopGrip for MagSafe is not only stylish and functional, but it's also built to last. Made from high-quality materials, this phone grip and stand is durable and will withstand regular use. It's designed to be used for a long time, making it a worthwhile investment for anyone who wants to improve their phone experience.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Get a Grip on Your Phone - Invest in PopSockets: Phone Grip for MagSafe`,
                        text: `If you're tired of dropping your phone or struggling to hold it for extended periods, the PopSockets PopGrip for MagSafe is the perfect accessory for you. Not only does it provide a secure grip and stand, but its customizable design allows you to express your personal style. Make your phone experience more comfortable and convenient with the PopSockets PopGrip for MagSafe.`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },

            // electronics
            {
                id: 6,
                title: 'Garmin Varia RTL515, Cycling Rearview Radar with Tail Light, Visual and Audible Alerts for Vehicles Up to 153 Yards Away, 010-02376-00, One Size',
                category: 'electronicsandgadgets',
                redirectionLink: 'https://amzn.to/3lCv1xM',
                images:[
                    {id: 'radar1', img: radar1},
                    {id: 'radar2', img: radar2},
                    {id: 'radar3', img: radar3},
                    {id: 'radar4', img: radar4},
                    {id: 'radar5', img: radar5},
                ],
                blog:{
                    title: 'Stay Safe on Your Bike with Garmin Varia RTL515: The Ultimate Cycling Rearview Radar',

                    introduction: {
                        heading: 'Revolutionize Your Cycling Experience with the Garmin Varia RTL515 Rearview Radar and Tail Light Combo',
                        text: `Cycling can be a great way to stay active and enjoy the outdoors, but it can also be dangerous, especially when sharing the road with vehicles. That's where the Garmin Varia RTL515 comes in. This cycling rearview radar is designed to help you stay safe on the road by providing visual and audible alerts for vehicles up to 153 yards away. In this blog, we'll explore why the Garmin Varia RTL515 is the ultimate cycling rearview radar and how it can help you stay safe on your bike.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Improved Safety',
                            text: `The Garmin Varia RTL515 provides cyclists with ample warning of approaching vehicles, allowing them to adjust their cycling behavior accordingly. The device's long detection range of up to 153 yards provides cyclists with enough time to react and make necessary adjustments. Additionally, the device provides both visual and audible alerts, ensuring that cyclists are aware of approaching vehicles. The device's radar tail light further enhances your safety on the road by increasing your visibility and making you more visible to other road users.`
                        },
                        {
                            id: 2,
                            heading: 'Increased Visibility',
                            text: `The tail light of the Garmin Varia RTL515 is designed to increase your visibility on the road. With its bright 20-lumen output, it's easily visible in daylight, providing added safety for cyclists in any conditions. The tail light also includes a flashing mode, further increasing your visibility and making you more visible to approaching vehicles.`
                        },
                        {
                            id: 3,
                            heading: 'Ease of Use',
                            text: `The Garmin Varia RTL515 is designed to be easy to use, even for beginners. The device comes with clear instructions and can be easily mounted to your bike. Once mounted, the device is simple to operate, with intuitive controls that allow you to customize the alerts and adjust the brightness of the tail light.`
                        },
                        {
                            id: 4,
                            heading: 'Compatibility',
                            text: `One of the key advantages of the Garmin Varia RTL515 is its compatibility with other Garmin devices. The device can be easily integrated into your existing Garmin cycling setup, providing a seamless user experience. This integration allows for more advanced features, such as integration with the Garmin Edge GPS cycling computer. Additionally, the device is compatible with both Android and iOS devices, making it easy to use with your smartphone.`
                        },
                        {
                            id: 5,
                            heading: 'User Reviews',
                            text: `Cyclists who have used the Garmin Varia RTL515 have reported feeling safer and more confident on the road. Many users praise the device's advanced features, such as the long detection range and visual and audible alerts. Others appreciate the added safety provided by the tail light, especially when cycling in low light conditions. Overall, the Garmin Varia RTL515 has received overwhelmingly positive reviews from users, making it a top choice for anyone looking to stay safe while cycling.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `A Purchase You Won't Regret`,
                        text: `The Garmin Varia RTL515 is designed to provide cyclists with advanced safety features and ease of use. Its long detection range, visual and audible alerts, and tail light provide ample warning of approaching vehicles, and the device is compatible with other Garmin devices and can be used with both Android and iOS smartphones. Many cyclists who have invested in the Garmin Varia RTL515 have reported feeling more confident and secure on the road. The overwhelmingly positive user reviews further confirm its effectiveness and user satisfaction. Investing in the Garmin Varia RTL515 is a decision you won't regret.`
                    }
                }
            },
            {
                id: 7,
                title: 'Panasonic LUMIX ZS80, 20.3 Megapixel Digital Camera, 4K Video, 30X Zoom Leica Lens DC-ZS80S (Silver), Bundle with Camera Bag + Mac Software Kit + 32GB SD Card + Cleaning Kit + Card Reader',
                category: 'electronicsandgadgets',
                redirectionLink: 'https://amzn.to/3K7aCup',
                images:[
                    {id: 'camera1', img: camera1},
                    {id: 'camera2', img: camera2},
                    {id: 'camera3', img: camera3},
                    {id: 'camera4', img: camera4},
                    {id: 'camera5', img: camera5},
                    {id: 'camera6', img: camera6},
                ],
                blog:{
                    title: 'Unleash Your Creativity with the Panasonic LUMIX ZS80 Digital Camera Bundle',

                    introduction: {
                        heading: `Capture Life's Moments in High Definition with the Panasonic LUMIX ZS80 Digital Camera Bundle`,
                        text: `Looking for a powerful digital camera that captures stunning 20.3 megapixel photos and 4K videos? Check out the Panasonic LUMIX ZS80 Digital Camera Bundle, which includes a 30X zoom Leica lens and a range of useful accessories to take your photography to the next level.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Capture Crystal Clear Images',
                            text: `With a 20.3 megapixel sensor and a 30X zoom Leica lens, the Panasonic LUMIX ZS80 Digital Camera delivers stunning images with vivid colors and crisp details. Whether you're shooting landscapes, portraits, or action scenes, this camera has you covered.`
                        },
                        {
                            id: 2,
                            heading: 'Shoot Cinematic 4K Videos',
                            text: `In addition to capturing amazing photos, the Panasonic LUMIX ZS80 Digital Camera also shoots stunning 4K videos. With 4 times the resolution of Full HD, 4K videos look incredibly cinematic and lifelike. Plus, with built-in image stabilization, your videos will look smooth and steady.`
                        },
                        {
                            id: 3,
                            heading: 'Compact and Portable',
                            text: `Despite its powerful features, the Panasonic LUMIX ZS80 Digital Camera is surprisingly compact and lightweight. You can easily take it with you on trips, hikes, or anywhere else you go.`
                        },
                        {
                            id: 4,
                            heading: 'Complete Bundle for Your Convenience',
                            text: `This bundle comes with a camera bag, Mac software kit, 32GB SD card, cleaning kit, and card reader, so you'll have everything you need to start taking amazing photos and videos right away. Plus, the bundle makes a great gift for anyone who loves photography.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Upgrade Your Photos Today - Panasonic LUMIX ZS80`,
                        text: `Investing in the Panasonic LUMIX ZS80 Digital Camera Bundle is a purchase you won't regret. With its powerful features, compact design, and convenient accessories, this camera is sure to revolutionize your photography. So why wait? Order yours today and start capturing memories that will last a lifetime.`
                    }
                }
            },
            {
                id: 8,
                title: 'Duracell Coppertop AAA Batteries with Power Boost Ingredients, 20 Count Pack Triple A Battery with Long-lasting Power, Alkaline AAA Battery for Household and Office Devices',
                category: 'electronicsandgadgets',
                redirectionLink: 'https://amzn.to/3JKIax3',
                images:[
                    {id: 'cell1', img: cell1},
                    {id: 'cell2', img: cell2},
                    {id: 'cell3', img: cell3},
                    {id: 'cell4', img: cell4},
                    {id: 'cell5', img: cell5},
                ],
                blog:{
                    title: 'Experience Long-Lasting Power with Duracell Coppertop AAA Batteries',

                    introduction: {
                        heading: 'Say Goodbye to Frequent Battery Replacements with Duracell Coppertop AAA Batteries',
                        text: `Looking for reliable and long-lasting batteries for your household or office devices? Look no further than Duracell Coppertop AAA Batteries, which come packed with Power Boost ingredients and provide dependable performance for a wide range of electronics.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Power Up Your Devices',
                            text: `Whether you need to power up your TV remote, gaming controller, flashlight, or any other electronic device, Duracell Coppertop AAA Batteries deliver the long-lasting power you need. With 20 batteries in each pack, you'll have plenty of backup power for all your devices.`
                        },
                        {
                            id: 2,
                            heading: 'Advanced Power Boost Ingredients',
                            text: `Duracell Coppertop AAA Batteries are engineered with advanced Power Boost ingredients, which provide extra energy to your devices and help them last longer. You'll be able to get more use out of your batteries than ever before.`
                        },
                        {
                            id: 3,
                            heading: 'Dependable Performance',
                            text: `Duracell is a trusted brand for a reason - their batteries deliver consistent and reliable performance. With Duracell Coppertop AAA Batteries, you can trust that your devices will work when you need them most.`
                        },
                        {
                            id: 4,
                            heading: 'Convenient and Versatile',
                            text: `Whether you need batteries for your TV remote, wireless keyboard, computer mouse, or any other device, Duracell Coppertop AAA Batteries are versatile enough to power them all. Plus, they come in a convenient pack that's easy to store and transport.`
                        },
                        {
                            id: 5,
                            heading: 'Convenient Packaging',
                            text: `The 20-count pack of Duracell Coppertop AAA Batteries comes in convenient packaging that's easy to store and transport, making it simple to keep a supply of reliable batteries on hand.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Power Up Your Life`,
                        text: `Investing in Duracell Coppertop AAA Batteries is a smart choice for anyone who needs reliable and long-lasting power for their devices. With their advanced Power Boost ingredients and dependable performance, these batteries are sure to power up your life. So why wait? Get your pack of Duracell Coppertop AAA Batteries today and enjoy the peace of mind that comes with reliable power.`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 9,
                title: 'UBeesize 10" Selfie Ring Light with Tripod Stand & Cell Phone Holder, Dimmable Desktop LED Circle Light for Live Streaming/Makeup/YouTube/TIK Tok, Compatible with iOS and Android Phones',
                category: 'electronicsandgadgets',
                redirectionLink: 'https://amzn.to/3FNFIo1',
                images:[
                    {id: 'ring1', img: ring1},
                    {id: 'ring2', img: ring2},
                    {id: 'ring3', img: ring3},
                    {id: 'ring4', img: ring4},
                    {id: 'ring5', img: ring5},
                ],
                blog:{
                    title: 'Illuminate Your World with the UBeesize 10" Selfie Ring Light',

                    introduction: {
                        heading: 'Enhance Your Selfies and Videos with the UBeesize 10" Ring Light and Tripod Stand',
                        text: `The UBeesize 10" Selfie Ring Light is a must-have for anyone looking to take their photos and videos to the next level. This versatile ring light features a dimmable LED circle light and a sturdy tripod stand, making it perfect for live streaming, makeup application, YouTube videos, and more. Compatible with both iOS and Android phones, the UBeesize 10" Selfie Ring Light is the perfect tool to help you achieve your goals.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Brighten Up Your Life',
                            text: `With the UBeesize 10" Selfie Ring Light, you'll never have to worry about poor lighting again. Its dimmable LED light provides bright and even illumination, ensuring that you always look your best. Plus, the included tripod stand and cell phone holder make it easy to position the light at the perfect angle for your needs.`
                        },
                        {
                            id: 2,
                            heading: 'Compatible with Your Devices',
                            text: `The UBeesize 10" Selfie Ring Light is compatible with both iOS and Android phones, making it a versatile choice for anyone. Whether you're using an iPhone, Samsung Galaxy, or any other smartphone, this ring light is sure to provide the perfect lighting for your needs.`
                        },
                        {
                            id: 3,
                            heading: 'Perfect for a Wide Range of Uses',
                            text: `Whether you're a makeup artist, live streamer, or aspiring YouTuber, the UBeesize 10" Selfie Ring Light is the perfect tool to help you achieve your goals. Its dimmable LED light can be adjusted to fit any situation, from bright and bold to soft and subtle.`
                        },
                        {
                            id: 4,
                            heading: 'Sturdy and Durable',
                            text: `The UBeesize 10" Selfie Ring Light is built to last, with a sturdy tripod stand that provides stable support for your phone and the ring light. Plus, the cell phone holder is adjustable to fit a variety of phone sizes, ensuring that you can use it with all your devices.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Get Your UBeesize 10" Selfie Ring Light Today`,
                        text: `If you're ready to take your photos and videos to the next level, the UBeesize 10" Selfie Ring Light is the perfect tool for the job. With its dimmable LED light, sturdy tripod stand, and versatile compatibility, this ring light is sure to become an essential part of your photo and video toolkit. So why wait? Get yours today and start illuminating your world!`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 10,
                title: 'HP Sprocket Select Portable 2.3x3.4" Instant Photo Printer (Eclipse) Print Pictures on Zink Sticky-Backed Paper from your iOS & Android Device.',
                category: 'electronicsandgadgets',
                redirectionLink: 'https://amzn.to/3TVjO8x',
                images:[
                    {id: 'sprocket1', img: sprocket1},
                    {id: 'sprocket2', img: sprocket2},
                    {id: 'sprocket3', img: sprocket3},
                    {id: 'sprocket4', img: sprocket4},
                    {id: 'sprocket5', img: sprocket5},
                ],
                blog:{
                    title: 'The Ultimate Portable Photo Printing Experience',

                    introduction: {
                        heading: 'Print Your Memories Anywhere with the HP Sprocket Select',
                        text: `Are you tired of scrolling through your phone's camera roll and never actually printing any of your photos? The HP Sprocket Select Portable Instant Photo Printer is here to help. With its compact size and convenient portability, you can print high-quality photos anytime, anywhere. Plus, with its compatibility with both iOS and Android devices, you can print photos from virtually any smartphone or tablet.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'High-Quality Prints',
                            text: `The HP Sprocket Select uses Zink sticky-backed paper to produce 2.3x3.4 inch photos that are smudge-proof, water-resistant, and tear-resistant. Plus, with 313 x 400 dpi resolution, your photos will look sharp and vibrant.`
                        },
                        {
                            id: 2,
                            heading: 'Portable Size',
                            text: `Measuring at just 3.15 x 4.63 x 0.98 inches and weighing only 0.38 lbs, the HP Sprocket Select is small enough to fit in your pocket or bag. It's the perfect size for on-the-go photo printing.`
                        },
                        {
                            id: 3,
                            heading: 'Easy Connectivity',
                            text: `The HP Sprocket Select connects to your phone or tablet via Bluetooth, making it easy to print photos directly from your device.`
                        },
                        {
                            id: 4,
                            heading: 'Customizable Prints',
                            text: `With the HP Sprocket app, you can customize your photos with borders, emojis, stickers, and more before printing them. You can even use the app to create collages or tile prints.`
                        },
                        {
                            id: 5,
                            heading: 'Long Battery Life',
                            text: `The HP Sprocket Select has a built-in rechargeable battery that can print up to 30 photos per charge. Plus, with the included micro USB cable, you can easily recharge the printer on the go.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `A Purchase You Won't Regret`,
                        text: `Don't miss out on the opportunity to preserve your favorite memories with the HP Sprocket Select Portable Instant Photo Printer. It's a purchase you won't regret.`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
           
            // home
            {
                id: 11,
                title: 'NutriChef PKVS Sealer | Automatic Vacuum Air Sealing System Preservation w/Starter Kit | Compact Design | Lab Tested | Dry & Moist Food Modes | Led Indicator Lights, 12", Silver',
                category: 'homeandkitchenappliances',
                redirectionLink: 'https://amzn.to/3FPTern',
                images:[
                    {id: 'nutriChef1', img: nutriChef1},
                    {id: 'nutriChef2', img: nutriChef2},
                    {id: 'nutriChef3', img: nutriChef3},
                    {id: 'nutriChef4', img: nutriChef4},
                    {id: 'nutriChef5', img: nutriChef5},
                    {id: 'nutriChef6', img: nutriChef6},
                ],
                blog:{
                    title: 'Preserve Your Food with NutriChef PKVS Sealer',

                    introduction: {
                        heading: 'Keep Your Food Fresh for Longer with NutriChef PKVS Sealer',
                        text: `Are you tired of throwing away spoiled food? Look no further than the NutriChef PKVS Sealer. This compact and easy-to-use system will revolutionize the way you store your food, ensuring it stays fresh for longer.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Lab-Tested for Quality Assurance',
                            text: `The NutriChef PKVS Sealer has been rigorously tested in a laboratory to ensure its effectiveness in preserving food. You can trust that this product will keep your food fresh and safe to eat.`
                        },
                        {
                            id: 2,
                            heading: 'Dry and Moist Food Modes for Versatility',
                            text: `Whether you're storing dry goods like nuts and crackers, or moist foods like meat and fish, the NutriChef PKVS Sealer has you covered. With two different modes, you can customize your food storage to your specific needs.`
                        },
                        {
                            id: 3,
                            heading: 'LED Indicator Lights for Easy Use',
                            text: `The NutriChef PKVS Sealer features LED lights that make it easy to see the progress of your vacuum-sealing process. You'll always know when your food is ready to store.`
                        },
                        {
                            id: 4,
                            heading: 'A Starter Kit for Your Convenience',
                            text: `The NutriChef PKVS Sealer comes with a starter kit that includes everything you need to get started, including vacuum sealer bags, a wine stopper cork, and an air suction hose..`
                        },
                    ],
                    
                    conclusion: {
                        heading: `A Purchase You Won't Regret`,
                        text: `Investing in the NutriChef PKVS Sealer is a purchase you won't regret. Say goodbye to wasted food and hello to a more efficient and cost-effective way of storing your groceries. Get yours today and start preserving your food with ease.`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 12,
                title: 'Rachael Ray Gadgets Utensil Kitchen Cooking Tools Set, 6 Piece, Orange',
                category: 'homeandkitchenappliances',
                redirectionLink: 'https://amzn.to/3ZdXrvK',
                images:[
                    {id: 'utensil1', img: utensil1},
                    {id: 'utensil2', img: utensil2},
                    {id: 'utensil3', img: utensil3},
                    {id: 'utensil4', img: utensil4},
                    {id: 'utensil5', img: utensil5},
                    {id: 'utensil6', img: utensil6},
                ],
                blog:{
                    title: 'Add Some Flavor to Your Kitchen with the Rachael Ray Kitchen Tools Set',

                    introduction: {
                        heading: 'Cook Like a Pro with the Rachael Ray Kitchen Tools Set',
                        text: `Looking for the perfect kitchen tools to elevate your cooking game? Look no further than the Rachael Ray Gadgets Utensil Kitchen Cooking Tools Set. With six versatile and durable tools in a bold orange hue, this set is a must-have for any home chef.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Elevate Your Cooking Game with Rachael Ray Kitchen Tools',
                            text: `Designed by a pro chef, the Rachael Ray Kitchen Tools Set includes all the essentials you need to cook like a pro. With six pieces, you'll have everything you need to whip up any recipe.`
                        },
                        {
                            id: 2,
                            heading: 'Durable and Versatile Utensils for Every Task',
                            text: `Made from sturdy nylon, these utensils can handle the toughest jobs in the kitchen. Plus, with six versatile pieces, you can use them for everything from sautéing and stirring to serving and flipping.`
                        },
                        {
                            id: 3,
                            heading: 'Bold Orange Color Adds a Pop of Fun to Your Kitchen',
                            text: `Who says kitchen tools have to be boring? The bold orange hue of these utensils adds a fun and playful touch to any kitchen. Plus, they're easy to spot in a crowded utensil drawer.`
                        },
                        {
                            id: 4,
                            heading: 'Comfortable Grips for Easy Handling',
                            text: `Each utensil in this set features a comfortable grip that makes cooking a breeze. Whether you're cooking up a storm or just whipping up a quick meal, you'll appreciate the ergonomic design of these tools.`
                        },
                        {
                            id: 5,
                            heading: 'The Perfect Gift for Any Home Cook',
                            text: `Know someone who loves to cook? The Rachael Ray Gadgets Utensil Kitchen Cooking Tools Set makes the perfect gift. With six essential tools in a fun and playful color, they'll be cooking up a storm in no time.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `The Only Set You'll Ever Need - Rachael Ray Gadgets Set`,
                        text: `If you're serious about cooking, you need the right tools for the job. The Rachael Ray Gadgets Utensil Kitchen Cooking Tools Set includes all the essentials you need to elevate your cooking game. From the durable nylon construction to the bold orange color, these tools are sure to become your new go-to utensils in the kitchen. Order yours today and start cooking like a pro!`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 13,
                title: 'Presto 01282 8-Quart Aluminum Pressure Cooker',
                category: 'homeandkitchenappliances',
                redirectionLink: 'https://amzn.to/3za6wLr',
                images:[
                    {id: 'cooker1', img: cooker1},
                    {id: 'cooker2', img: cooker2},
                    {id: 'cooker3', img: cooker3},
                    {id: 'cooker4', img: cooker4},
                ],
                blog:{
                    title: 'Discover the Secret to Perfectly Cooked Meals with the Presto 01282 Pressure Cooker',

                    introduction: {
                        heading: 'Cook Faster and Healthier with the Presto Aluminum Pressure Cooker',
                        text: `If you're looking for a way to cook faster, save energy, and enjoy healthier meals, the Presto 01282 8-Quart Aluminum Pressure Cooker is the perfect solution. With its unique pressure cooking technology and durable aluminum construction, this pressure cooker is a must-have for any home cook.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Pressure Cooking Technology Saves Time and Energy',
                            text: `With the Presto Aluminum Pressure Cooker, you can cook up to 70% faster than with traditional cooking methods. The pressure cooking technology allows you to cook meals quickly and efficiently, saving you time and energy.`
                        },
                        {
                            id: 2,
                            heading: 'Durable Aluminum Construction for Long-Lasting Use',
                            text: `Made from high-quality aluminum, this pressure cooker is designed to last. It's built to withstand daily use, and the durable construction ensures that it will be a staple in your kitchen for years to come.`
                        },
                        {
                            id: 3,
                            heading: 'Easy to Use and Clean',
                            text: `The Presto Aluminum Pressure Cooker is incredibly easy to use. Simply add your ingredients, lock the lid in place, and let the pressure cooker do the rest. Plus, the cooker is easy to clean, with a non-stick interior that makes cleanup a breeze.`
                        },
                        {
                            id: 4,
                            heading: 'Perfect for Healthy Cooking',
                            text: `One of the biggest benefits of pressure cooking is that it helps to retain nutrients in your food, making it a healthier cooking method. Plus, you can cook with less oil and fat, making it a great option for those looking to eat healthier.`
                        },
                        {
                            id: 5,
                            heading: 'Versatile Cooking Options for Any Recipe',
                            text: `The Presto Aluminum Pressure Cooker is incredibly versatile, allowing you to cook a wide variety of recipes with ease. From stews and soups to rice and beans, this pressure cooker can handle it all.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `A Purchase You Won't Regret`,
                        text: `If you're looking for a way to cook faster, save energy, and enjoy healthier meals, the Presto 01282 8-Quart Aluminum Pressure Cooker is the perfect solution. With its unique pressure cooking technology, durable aluminum construction, and easy-to-use design, this pressure cooker is a must-have for any home cook. Order yours today and start enjoying fast, healthy, and delicious meals in no time!`
                    },
                }
            },
            {
                id: 14,
                title: 'Ovente Electric Sandwich Maker with Non-Stick Plates, 750W Indoor Grill Kitchen or Dorm Essentials Easy to Clean and Storage, Perfect for Breakfast Grilled Cheese Egg Bacon and Steak, Black GPS401B',
                category: 'homeandkitchenappliances',
                redirectionLink: 'https://amzn.to/3Zj16IF',
                images:[
                    {id: 'oven1', img: oven1},
                    {id: 'oven2', img: oven2},
                    {id: 'oven3', img: oven3},
                    {id: 'oven4', img: oven4},
                    {id: 'oven5', img: oven5},
                ],
                blog:{
                    title: 'Make Delicious Sandwiches in Minutes with Ovente',

                    introduction: {
                        heading: 'Start Your Day Right with the Ovente Electric Sandwich Maker',
                        text: `If you're a fan of breakfast sandwiches or grilled cheese, the Ovente Electric Sandwich Maker is the perfect addition to your kitchen. With its non-stick plates, easy-to-use design, and compact size, this sandwich maker is a must-have for anyone who loves delicious and easy-to-make meals.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Non-Stick Plates for Easy Cooking and Cleaning',
                            text: `The Ovente Electric Sandwich Maker features non-stick plates, which make cooking and cleaning a breeze. No more scraping burnt cheese off the plates or struggling to clean stuck-on food. Simply wipe the plates down with a damp cloth or sponge, and your sandwich maker will be ready for its next use.`
                        },
                        {
                            id: 2,
                            heading: 'Compact Size for Easy Storage',
                            text: `This sandwich maker is the perfect size for small kitchens or dorm rooms. It's compact and lightweight, making it easy to store away when not in use. Plus, the sleek black design makes it a stylish addition to any kitchen.`
                        },
                        {
                            id: 3,
                            heading: 'Versatile Cooking Options for Any Recipe',
                            text: `The Ovente Electric Sandwich Maker is incredibly versatile, allowing you to cook a wide variety of recipes with ease. From breakfast sandwiches and grilled cheese to eggs, bacon, and even steak, this sandwich maker can handle it all.`
                        },
                        {
                            id: 4,
                            heading: 'Quick and Easy to Use',
                            text: `Making breakfast has never been easier. Simply plug in the sandwich maker, let it preheat for a few minutes, and you're ready to start cooking. The non-stick plates ensure that your food won't stick, and the 750W heating element ensures that your food cooks evenly and quickly.`
                        },
                        {
                            id: 5,
                            heading: 'Perfect for Busy Mornings',
                            text: `If you're always rushing out the door in the morning, the Ovente Electric Sandwich Maker is the perfect solution. It's quick, easy, and mess-free, making it a great option for busy mornings when you don't have time to sit down for a meal.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Upgrade Your Kitchen with Ovente Sandwich Maker`,
                        text: `If you're looking for an easy and convenient way to make delicious breakfast sandwiches and grilled cheese, the Ovente Electric Sandwich Maker is the perfect solution. With its non-stick plates, easy-to-use design, and compact size, this sandwich maker is a must-have for any kitchen. Order yours today and start enjoying quick, easy, and delicious meals in no time!`
                    },
                }
            },
            {
                id: 15,
                title: 'KitchenArt 57010 Select-A-Spice Auto-Measure Carousel Professional Series, Satin',
                category: 'homeandkitchenappliances',
                redirectionLink: 'https://amzn.to/3K4uTAJ',
                images:[
                    {id: 'art1', img: art1},
                    {id: 'art2', img: art2},
                    {id: 'art3', img: art3},
                    {id: 'art4', img: art4},
                    {id: 'art5', img: art5},
                ],
                blog:{
                    title: 'Streamline Your Spice Game with the KitchenArt Select-A-Spice Carousel',

                    introduction: {
                        heading: `Upgrade Your Spice Game with KitchenArt 57010 Select-A-Spice Auto-Measure Carousel - The Professional's Choice!`,
                        text: `Are you tired of digging through a jumbled spice cabinet every time you cook? The KitchenArt Select-A-Spice Carousel offers a sleek and efficient solution to your spice storage and measuring needs.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Keep Your Spices Organized and Accessible',
                            text: `The KitchenArt Select-A-Spice Carousel offers a convenient way to store and organize up to 12 different spices in one compact carousel. With each jar attached to the carousel, you can easily access and identify each spice without having to dig through a cluttered cabinet.`
                        },
                        {
                            id: 2,
                            heading: 'Accurately Measure Spices Every Time with Auto-Measure Function',
                            text: `The carousel's auto-measure feature allows you to dispense the perfect amount of spice every time, thanks to its adjustable measuring dial. Simply turn the dial to your desired measurement and the carousel will dispense the spice for you, ensuring consistent and accurate seasoning.`
                        },
                        {
                            id: 3,
                            heading: 'Professional-Grade Quality and Durability',
                            text: `Made from high-quality materials and designed for professional use, the KitchenArt Select-A-Spice Carousel is built to last. Its durable plastic jars and stainless steel construction ensure that it will withstand the rigors of daily use.`
                        },
                        {
                            id: 4,
                            heading: 'Stylish and Compact Design Fits Any Kitchen Decor',
                            text: `The sleek and modern design of the KitchenArt Select-A-Spice Carousel adds a touch of elegance to any kitchen. Its compact size means it won't take up too much counter space, while its satin finish gives it a stylish and sophisticated look.`
                        },
                        {
                            id: 5,
                            heading: `The Perfect Addition to Any Home Chef's Kitchen`,
                            text: `Whether you're an experienced chef or a beginner cook, the KitchenArt Select-A-Spice Carousel is an essential tool for any home kitchen. Its convenience, accuracy, and durability make it a must-have for anyone who loves to cook and wants to streamline their spice game.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Elevate Your Cooking Game Today`,
                        text: `This professional-grade spice organizer and measuring tool will help you save time, stay organized, and simplify your cooking routine. Don't settle for a cluttered spice cabinet - invest in the KitchenArt Select-A-Spice Carousel today and take your cooking to the next level.`
                    },
                }
            },
            
            // beauty
            {
                id: 16,
                title: 'First Aid Beauty KP Bump Eraser Body Scrub Exfoliant for Keratosis Pilaris with 10% AHA 2 oz.',
                category: 'beautyandpersonalcare',
                redirectionLink: 'https://amzn.to/3zah7WX',
                images:[
                    {id: 'firstAid1', img: firstAid1},
                    {id: 'firstAid2', img: firstAid2},
                    {id: 'firstAid3', img: firstAid3},
                    {id: 'firstAid4', img: firstAid4},
                    {id: 'firstAid5', img: firstAid5},
                ],
                blog:{
                    title: 'Goodbye Bumps! Discover the Miracle Body Scrub for Smooth, Flawless Skin',

                    introduction: {
                        heading: 'Get Rid of Stubborn Bumps with First Aid Beauty KP Bump Eraser Body Scrub',
                        text: `Are you tired of those pesky bumps on your arms and legs that just won't go away? Look no further than First Aid Beauty's KP Bump Eraser Body Scrub. With 10% AHA, this exfoliant is specially formulated to target Keratosis Pilaris and leave your skin feeling smooth and silky.`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Gentle Yet Effective Exfoliation',
                            text: `Say goodbye to harsh scrubs that leave your skin feeling raw and irritated. First Aid Beauty's KP Bump Eraser Body Scrub uses a combination of physical and chemical exfoliants to gently buff away dead skin cells and unclog pores, without causing any damage or discomfort.`
                        },
                        {
                            id: 2,
                            heading: 'Nourishing and Hydrating',
                            text: `Not only does this scrub exfoliate, but it also contains nourishing ingredients like glycerin and bisabolol to hydrate and soothe the skin. You'll be left with a healthy, radiant glow that lasts all day.`
                        },
                        {
                            id: 3,
                            heading: 'Convenient Size for On-the-Go',
                            text: `At just 2 oz., this body scrub is the perfect size for travel or throwing in your gym bag. You won't have to sacrifice your skincare routine just because you're on-the-go.`
                        },
                        {
                            id: 4,
                            heading: 'Safe for Sensitive Skin',
                            text: `If you have sensitive skin, you know how difficult it can be to find products that won't cause irritation or breakouts. First Aid Beauty's KP Bump Eraser Body Scrub is dermatologist-tested and safe for even the most delicate skin.`
                        },
                        {
                            id: 5,
                            heading: 'Results You Can See and Feel',
                            text: `Don't just take our word for it - try First Aid Beauty's KP Bump Eraser Body Scrub for yourself and see the results. You'll be amazed at how smooth and bump-free your skin can be.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `A Smoother, More Confident You`,
                        text: `Invest in yourself and your skin with First Aid Beauty's KP Bump Eraser Body Scrub. Say goodbye to bumpy, rough skin and hello to a smoother, more confident you. Your skin (and your confidence) will thank you.`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 17,
                title: 'Honest Beauty Tinted Lip Balm | Antioxidant-rich Acai Extracts + Avocado Oil | EWG Certified, Vegan, Cruelty Free | Lychee Fruit',
                category: 'beautyandpersonalcare',
                redirectionLink: 'https://amzn.to/3JL4syB',
                images:[
                    {id: 'lipbalm1', img: lipbalm1},
                    {id: 'lipbalm2', img: lipbalm2},
                    {id: 'lipbalm3', img: lipbalm3},
                    {id: 'lipbalm4', img: lipbalm4},
                    {id: 'lipbalm5', img: lipbalm5},
                ],
                blog:{
                    title: `Transform Your Lips with Honest Beauty's Tinted Lip Balm - Say Goodbye to Dryness and Hello to Radiant Lips!`,

                    introduction: {
                        heading: `Say Goodbye to Dry Lips with Honest Beauty's Tinted Lip Balm - A Must-Have in Your Beauty Arsenal!`,
                        text: `Are you tired of dealing with dry, cracked lips, especially during the colder months? Look no further than Honest Beauty's Tinted Lip Balm, formulated with nourishing ingredients like acai extracts and avocado oil. Here's why this product deserves a spot in your beauty arsenal:`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Antioxidant-Rich Formula',
                            text: `The acai extracts in this lip balm are packed with antioxidants that help protect your lips from damaging environmental factors, like pollution and UV rays. Plus, avocado oil helps to hydrate and soothe dry, chapped lips.`
                        },
                        {
                            id: 2,
                            heading: 'EWG Certified and Vegan',
                            text: `You can feel good about using Honest Beauty's Tinted Lip Balm, knowing that it's EWG (Environmental Working Group) certified, meaning it meets the organization's strict standards for health and safety. Additionally, this lip balm is vegan and cruelty-free, making it a great choice for conscious consumers.`
                        },
                        {
                            id: 3,
                            heading: 'Lychee Fruit for a Touch of Color',
                            text: `Not only does this lip balm nourish and protect your lips, but it also adds a pop of color with lychee fruit extract. The sheer, buildable formula allows you to customize your level of color, making it perfect for everyday wear.`
                        },
                        {
                            id: 4,
                            heading: 'Easy to Apply',
                            text: `Gone are the days of struggling with lipsticks or liquid lip stains. Honest Beauty's Tinted Lip Balm has a smooth, creamy texture that glides on easily and evenly, providing long-lasting hydration and color without any fuss.`
                        },
                        {
                            id: 5,
                            heading: 'Perfect for On-The-Go',
                            text: `This compact, lightweight lip balm is the perfect size for your purse, gym bag, or travel kit. You won't have to sacrifice your lip care routine, no matter where life takes you.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Healthy, Hydrated Lips in Seconds`,
                        text: `Invest in your lips with Honest Beauty's Tinted Lip Balm, a nourishing, easy-to-use product that will keep your lips looking and feeling their best. Say goodbye to dry, chapped lips, and hello to a healthy, hydrated pout in seconds.`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
            {
                id: 18,
                title: 'Dove Skin Care Beauty Bar For Softer Skin Cucumber and Green Tea More Moisturizing Than Bar Soap 3.75 oz, 14 Bars',
                category: 'beautyandpersonalcare',
                redirectionLink: 'https://amzn.to/3TOdkYS',
                images:[
                    {id: 'dove1', img: dove1},
                    {id: 'dove2', img: dove2},
                    {id: 'dove3', img: dove3},
                    {id: 'dove4', img: dove4},
                    {id: 'dove5', img: dove5},
                ],
                blog:{
                    title: `Say Goodbye to Dry, Flaky Skin with Dove's Moisturizing Beauty Bar - A Game-Changer in Skincare!`,

                    introduction: {
                        heading: `Unlock the Secret to Softer Skin with Dove's Beauty Bar - Your Skin Will Thank You!`,
                        text: `Looking for a gentle yet effective way to care for your skin? Dove's Beauty Bar with Cucumber and Green Tea is a must-try product. Here's why you need this in your skincare routine:`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'More Moisturizing than Bar Soap',
                            text: `Dove's Beauty Bar is not just any bar soap - it's a moisturizing beauty bar that helps nourish and hydrate your skin. Unlike traditional bar soaps that can strip your skin of its natural oils, this beauty bar is formulated to leave your skin feeling soft and smooth.`
                        },
                        {
                            id: 2,
                            heading: 'Cucumber and Green Tea for Refreshing Hydration',
                            text: `This beauty bar is enriched with refreshing cucumber and green tea extracts that help soothe and hydrate your skin, leaving it feeling revitalized and rejuvenated. Plus, the light, refreshing scent is a treat for your senses!`
                        },
                        {
                            id: 3,
                            heading: 'Perfect for Daily Use',
                            text: `Whether you have dry, oily, or combination skin, Dove's Beauty Bar is suitable for daily use. It's gentle enough to use on your face and body, making it a versatile product that can streamline your skincare routine.`
                        },
                        {
                            id: 4,
                            heading: '14 Bars for Long-Lasting Use',
                            text: `With 14 bars in a pack, you'll have plenty of product to last you for months. Plus, the convenient packaging makes it easy to store and use, whether you're at home or on-the-go.`
                        },
                        {
                            id: 5,
                            heading: 'Affordable Luxury for Your Skin',
                            text: `You don't need to break the bank to pamper your skin. Dove's Beauty Bar with Cucumber and Green Tea is an affordable yet luxurious product that can help transform your skin in just a few uses.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Experience Soft, Smooth, Glowing Skin with Dove's Beauty Bar`,
                        text: `Upgrade your skincare routine with Dove's Beauty Bar with Cucumber and Green Tea. Say goodbye to dry, flaky skin and hello to soft, smooth, glowing skin in no time!`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
             {
                id: 19,
                title: 'Finishing Touch Flawless Facial Hair Remover for Women, White/Rose Gold Electric Face Razor for Women with LED Light for Instant and Painless Hair Removal',
                category: 'beautyandpersonalcare',
                redirectionLink: 'https://amzn.to/3ZpknrX',
                images:[
                    {id: 'hairRemoval1', img: hairRemoval1},
                    {id: 'hairRemoval2', img: hairRemoval2},
                    {id: 'hairRemoval3', img: hairRemoval3},
                    {id: 'hairRemoval4', img: hairRemoval4},
                    {id: 'hairRemoval5', img: hairRemoval5},
                    {id: 'hairRemoval6', img: hairRemoval6},
                ],
                blog:{
                    title: `Get Perfectly Smooth Skin with Finishing Touch Flawless - The Ultimate Facial Hair Remover!`,

                    introduction: {
                        heading: `Get Rid of Unwanted Facial Hair with Finishing Touch Flawless - Your Secret to Perfectly Smooth Skin!`,
                        text: `If you're tired of painful and time-consuming hair removal methods, Finishing Touch Flawless is the answer to your prayers. Here's why you need this game-changing product in your beauty routine:`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Instant and Painless Hair Removal',
                            text: `Say goodbye to painful waxing and threading sessions! With Finishing Touch Flawless, you can remove unwanted facial hair instantly and painlessly. The electric face razor is gentle on your skin and delivers a smooth, flawless finish every time.`
                        },
                        {
                            id: 2,
                            heading: 'LED Light for Precision',
                            text: `The built-in LED light makes it easy to see and remove even the tiniest hairs with precision, ensuring that you never miss a spot. Plus, the compact design makes it easy to use on-the-go for touch-ups anytime, anywhere.`
                        },
                        {
                            id: 3,
                            heading: 'Suitable for All Skin Types',
                            text: `Whether you have sensitive, dry, oily, or combination skin, Finishing Touch Flawless is suitable for all skin types. The hypoallergenic, dermatologist-approved design ensures that your skin stays smooth and irritation-free.`
                        },
                        {
                            id: 4,
                            heading: 'Stylish and Easy to Use',
                            text: `The sleek white and rose gold design of the Finishing Touch Flawless is not just stylish, but also easy to use. Simply switch it on and glide it over your skin for perfect hair removal every time.`
                        },
                        {
                            id: 5,
                            heading: 'Affordable and Long-Lasting',
                            text: `Say goodbye to expensive hair removal treatments! Finishing Touch Flawless is an affordable, long-lasting investment that can save you time and money in the long run. Plus, the rechargeable battery ensures that you can use it for months before needing to replace it.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Say Goodbye to Unwanted Facial Hair with Finishing Touch Flawless`,
                        text: `Transform your beauty routine with Finishing Touch Flawless. Get the smooth, flawless skin you've always wanted with this game-changing facial hair remover!`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
                 {
                id: 20,
                title: 'Moroccanoil Hydrating Shampoo',
                category: 'beautyandpersonalcare',
                redirectionLink: 'https://amzn.to/3z9zpHL',
                images:[
                    {id: 'shampoo1', img: shampoo1},
                    {id: 'shampoo2', img: shampoo2},
                    {id: 'shampoo3', img: shampoo3},
                    {id: 'shampoo4', img: shampoo4},
                ],
                blog:{
                    title: `Unlock the Secret to Luscious, Hydrated Locks with Moroccanoil Hydrating Shampoo - Say Goodbye to Dry, Damaged Hair!`,

                    introduction: {
                        heading: `Transform Your Hair with Moroccanoil Hydrating Shampoo - The Ultimate Solution for Dry, Damaged Hair!`,
                        text: `Are you tired of dealing with dry, brittle hair that's prone to breakage? Look no further than Moroccanoil Hydrating Shampoo, the ultimate solution for achieving soft, smooth, and hydrated locks. Here's why you need this game-changing shampoo in your haircare routine:`
                    },

                    content:[
                        {
                            id: 1,
                            heading: 'Hydrates and Nourishes',
                            text: `Moroccanoil Hydrating Shampoo is formulated with argan oil, which is rich in vitamins, minerals, and antioxidants that help to hydrate and nourish your hair. Say goodbye to dry, damaged hair and hello to soft, shiny locks.`
                        },
                        {
                            id: 2,
                            heading: 'Gentle and Safe for All Hair Types',
                            text: `Whether you have curly, straight, fine, or thick hair, Moroccanoil Hydrating Shampoo is gentle and safe for all hair types. The sulfate-free formula is designed to cleanse your hair without stripping it of its natural oils, leaving it healthy and moisturized.`
                        },
                        {
                            id: 3,
                            heading: 'Restores and Revitalizes',
                            text: `If you're dealing with hair that's been damaged by heat styling or chemical treatments, Moroccanoil Hydrating Shampoo can help. The formula works to restore and revitalize your hair, leaving it looking and feeling healthier than ever before.`
                        },
                        {
                            id: 4,
                            heading: 'Adds Volume and Shine',
                            text: `In addition to hydrating and nourishing your hair, Moroccanoil Hydrating Shampoo also adds volume and shine. Say goodbye to flat, lifeless hair and hello to hair that's full of body and shine.`
                        },
                        {
                            id: 5,
                            heading: 'Luxurious and Invigorating',
                            text: `Not only does Moroccanoil Hydrating Shampoo work wonders for your hair, but it also provides a luxurious and invigorating experience. The shampoo has a refreshing scent that will leave you feeling relaxed and rejuvenated.`
                        },
                    ],
                    
                    conclusion: {
                        heading: `Experience the Transformation - Moroccanoil Hydrating Shampoo Will Take Your Haircare Routine to the Next Level!`,
                        text: `Moroccanoil Hydrating Shampoo is a must-have for anyone looking to transform their haircare routine. The argan oil-rich formula hydrates and nourishes your hair, leaving it healthy and revitalized. Its sulfate-free formula is gentle and safe for all hair types, making it the ultimate solution for dry, damaged hair. Upgrade your haircare game with Moroccanoil Hydrating Shampoo and enjoy soft, smooth, and hydrated locks.`
                    },
                    youtubeLink: 'http://www.youtube.com/watch?v=7KDRqBpT8NA&t=149s',
                }
            },
           
        ]
    },
    reducers:{
        setProductsByCategory:(state, action)=>{
            const category = action.payload;
            state.active = category;
        }
    }
});

export const {setProductsByCategory} = productsSlice.actions;

export default productsSlice.reducer;